
import axios from 'axios'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Selector from 'vux/src/components/selector/index.vue'

import { Debounce } from '../utils'
import Bus from '../bus'
import Disclaimer from './Disclaimer'
export default {
name:'AddFormView',
directives: {
TransferDom
},
components:{
Popup,TransferDom, Group, XButton, Flexbox, FlexboxItem, Toast, Grid, GridItem, Selector,Disclaimer
},
props:['showmodal','type','billId'],
watch:{
showmodal(v){
var el = document.getElementById('app')
this.scrollTop = v ? document.documentElement.scrollTop : this.scrollTop
el.hidden = v
if (!v) {
setTimeout(() => {
window.scrollTo({top:this.scrollTop||0, left:0})
}, 200)
}
},
billId(v){
this.queryDate(v)
}
},
data(){
return {
originatorNameText:'',
acceptNameText:'',
materialNameText:'',
tagtypeText:'',
tagStatusText:'',
name:'',
location:'',
enterpriseName:'',
phone:'',
supplierName:'',
supplierLocation:'',
supplierEnterpriseName:'',
supplierPhone:'',
isToast: false,
toastMsg: '提交成功',
toastType: 'success',
systemId: '',
executeStatus:'',
id:'',
details:[],
positionimg2: require('../assets/2.png'),
submitText:'',
telphone:'',
telSuphone:'',
}
},
methods:{
setIconType (v, icon) {
if (v == "") {
this[icon] = "error"
} else {
this[icon] = "success"
}
},
submit (){

Bus.$emit('open-formother',true,this.id)
},
queryDate (id) {
axios.get('/yuncai-yop/contribute/detail?id=' + id).then(response => {
if (response.data && response.data.status == 1) {
var res = response.data.data
this.name = res.name
this.id = res.id
this.location = res.location
this.enterpriseName = res.enterpriseName
this.phone = res.phone
this.supplierName = res.supplierName
this.supplierLocation = res.supplierLocation
this.supplierEnterpriseName = res.supplierEnterpriseName
this.supplierPhone = res.supplierPhone
this.details = res.details
this.executeStatus = res.executeStatus
this.telphone = "tel:"+res.phone
this.telSuphone = "tel:"+res.supplierPhone
}
})
},
close () {
Bus.$emit("close-modal",!this.showmodal)
},
},
mounted () {
var tag = window.location.search.split('=')[1]
if(tag && tag.includes('hzh')){

this.systemId = 1
}else{

this.systemId = 0
}

switch(this.type){
case 4:
this.originatorNameText = '募捐人信息'
this.materialNameText = '募捐物资信息'
this.tagtypeText = '公开募捐'
this.tagStatusText = '待捐赠'
this.submitText = '我要捐赠'
break;
case 5:
this.originatorNameText = '申请募捐人信息'
this.acceptNameText = '定向捐赠人信息'
this.materialNameText = '捐赠物资信息'
this.tagtypeText = '定向募捐'
break;
case 6:
this.originatorNameText = '捐赠人信息'
this.materialNameText = '捐赠物资信息'
this.tagtypeText = '公开捐赠'
this.tagStatusText = '待受捐'
this.submitText = '我要申请受捐'
break;
case 7:
this.originatorNameText = '捐赠人信息'
this.acceptNameText = '受捐人信息'
this.materialNameText = '捐赠物资信息'
this.tagtypeText = '定向捐赠'
break;
case 8:
this.originatorNameText = '供货人信息'
this.materialNameText = '供应物资信息'
this.tagtypeText = '公开供应'
this.tagStatusText = '待采购'
this.submitText = '我要采购'
break;
case 9:
this.originatorNameText = '供货人信息'
this.acceptNameText = '采购人信息'
this.materialNameText = '供应物资信息'
this.tagtypeText = '定向供应'
break;
case 10:
this.originatorNameText = '需求人信息'
this.materialNameText = '需求物资信息'
this.tagtypeText = '公开采购'
this.tagStatusText = '待供应'
this.submitText = '我要供应'
break;
case 11:
this.originatorNameText = '需求人信息'
this.acceptNameText = '供应人信息'
this.materialNameText = '需求物资信息'
this.tagtypeText = '定向采购'
break;
}

}
}



// WEBPACK FOOTER //
// ./src/components/AddFormView.vue